import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["children", "title", "isOpen", "setIsOpen", "size", "rounded", "padding"];
import clsx from "clsx";
import React, { Fragment, useCallback } from "react";
import { createMemoClass } from "../create-memo-class";
import { Dialog, Transition } from "@headlessui/react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Modal = props => {
  var {
    children,
    title,
    isOpen = true,
    setIsOpen = () => {},
    size = "md",
    rounded = true,
    padding = "md"
  } = props,
      rest = _objectWithoutPropertiesLoose(props, _excluded);

  var classes = useModalClass({
    size,
    rounded,
    padding
  });
  var closeModal = useCallback(() => {
    setIsOpen(false);
  }, []);
  return /*#__PURE__*/_jsx(Transition, {
    appear: true,
    show: isOpen,
    as: Fragment,
    children: /*#__PURE__*/_jsxs(Dialog, {
      as: "div",
      className: "relative z-10",
      onClose: closeModal,
      children: [/*#__PURE__*/_jsx(Transition.Child, {
        as: Fragment,
        enter: "ease-out duration-300",
        enterFrom: "opacity-0",
        enterTo: "opacity-100",
        leave: "ease-in duration-200",
        leaveFrom: "opacity-100",
        leaveTo: "opacity-0",
        children: /*#__PURE__*/_jsx("div", {
          className: "fixed inset-0 bg-black bg-opacity-25"
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "fixed inset-0 overflow-y-auto",
        children: /*#__PURE__*/_jsx("div", {
          className: "flex min-h-full items-center justify-center p-4 text-center",
          children: /*#__PURE__*/_jsx(Transition.Child, {
            as: Fragment,
            enter: "ease-out duration-300",
            enterFrom: "opacity-0 scale-95",
            enterTo: "opacity-100 scale-100",
            leave: "ease-in duration-200",
            leaveFrom: "opacity-100 scale-100",
            leaveTo: "opacity-0 scale-95",
            children: /*#__PURE__*/_jsxs(Dialog.Panel, {
              className: classes,
              children: [title && /*#__PURE__*/_jsx(Dialog.Title, {
                as: "h3",
                className: "text-lg font-medium leading-6 text-gray-900",
                children: title
              }), children, /*#__PURE__*/_jsx("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                onClick: closeModal,
                className: "h-8 w-8 absolute -right-3 rounded-full bg-ccq-yellow hover:bg-ccq-blue hover:text-white p-2 -top-3 cursor-pointer",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor",
                strokeWidth: 2,
                children: /*#__PURE__*/_jsx("path", {
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                  d: "M6 18L18 6M6 6l12 12"
                })
              })]
            })
          })
        })
      })]
    })
  });
};
var useModalClass = createMemoClass(props => {
  var sizes = {
    md: "max-w-md",
    lg: "max-w-lg",
    sm: "max-w-sm",
    xl: "max-w-xl"
  };
  var paddings = {
    null: "p-0",
    sm: "p-3",
    md: "p-6",
    lg: "p-9"
  };
  return clsx("w-full transform  bg-white  text-left align-middle shadow-xl transition-all", sizes[props.size], {
    "rounded-2xl": props.rounded
  }, paddings[props.padding]);
});
//# sourceMappingURL=modal.js.map